// PF wage ceiling: 15,000 for payroll periods before Oct 2026, 25,000 from Oct 2026 onward
export const PF_LIMIT_OLD = 15000;
export const PF_LIMIT_NEW = 25000;
export const PF_LIMIT_EFFECTIVE_FROM = "2026-10-01";

// periodDate: "YYYY-MM-DD" (or ISO string) of the payroll period; pass the period end date
export const getPfLimit = (periodDate) => {
  if (!periodDate) return PF_LIMIT_NEW;
  return String(periodDate).slice(0, 10) >= PF_LIMIT_EFFECTIVE_FROM
    ? PF_LIMIT_NEW
    : PF_LIMIT_OLD;
};
